import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { toSignal } from '@angular/core/rxjs-interop';
import { initialState } from '../store/index.reducer';
import { $themeConfig } from '../theme.config';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AppService {
    constructor(public translate: TranslateService, public store: Store<any>) {
        this.initStoreData();
    }

    /** NgRx `index` slice as an Angular signal — use as `store()` in templates when aliased. */
    readonly indexState = toSignal(this.store.select((d: any) => d.index), {
        initialValue: initialState,
    });

    /** Legacy accessor — prefer `indexState()` for new code. */
    get storeData(): typeof initialState {
        return this.indexState();
    }

    initStoreData() {
        // set default styles
        let val: any = localStorage.getItem('theme'); // light, dark, system
        val = val || $themeConfig.theme;
        this.store.dispatch({ type: 'toggleTheme', payload: val });

        val = localStorage.getItem('menu'); // vertical, collapsible-vertical, horizontal
        val = val || $themeConfig.menu;
        this.store.dispatch({ type: 'toggleMenu', payload: val });

        val = localStorage.getItem('layout'); // full, boxed-layout
        val = val || $themeConfig.layout;
        this.store.dispatch({ type: 'toggleLayout', payload: val });

        val = localStorage.getItem('i18n_locale'); // en, da, de, el, es, fr, hu, it, ja, pl, pt, ru, sv, tr, zh
        val = val || $themeConfig.locale;

        const list = this.indexState().languageList;
        const item = list.find((item: any) => item.code === val);
        if (item) {
            this.toggleLanguage(item);
        }

        val = localStorage.getItem('rtlClass'); // rtl, ltr
        val = val || $themeConfig.rtlClass;
        this.store.dispatch({ type: 'toggleRTL', payload: val });

        val = localStorage.getItem('animation'); // animate__fadeIn, ...
        val = val || $themeConfig.animation;
        this.store.dispatch({ type: 'toggleAnimation', payload: val });

        val = localStorage.getItem('navbar'); // navbar-sticky, navbar-floating, navbar-static
        val = val || $themeConfig.navbar;
        this.store.dispatch({ type: 'toggleNavbar', payload: val });

        val = localStorage.getItem('semidark');
        val = val === 'true' ? true : $themeConfig.semidark;
        this.store.dispatch({ type: 'toggleSemidark', payload: val });
    }

    toggleLanguage(item: any) {
        let lang: any = null;
        lang = 'en';
        if (item) {
            lang = item;
        } else {
            let code = this.translate.currentLang || null;
            if (!code) {
                code = localStorage.getItem('i18n_locale');
            }

            item = this.indexState().languageList.find((d: any) => d.code === code);
            if (item) {
                lang = item;
            }
        }

        if (!lang) {
            lang = this.indexState().languageList.find((d: any) => d.code === 'en');
        }

        this.translate.use(lang.code); // set language
        this.store.dispatch({ type: 'toggleLocale', payload: lang.code });
        return lang;
    }

    changeAnimation(type = 'add') {
        const anim = this.indexState().animation;
        if (anim) {
            const ele: any = document.querySelector('.animation');
            if (type === 'add') {
                ele?.classList.add('animate__animated', anim);
            } else {
                ele?.classList.remove('animate__animated', anim);
            }
        }
    }
}
